import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import List from 'yoda-core-components/lib/components/List/List';
import config from 'yoda-core-components/lib/components/List/List/List.config';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import CartItem from '../CartItem/CartItem';
import * as styles from './CartItemsList.css';
import RemovedCartItemMessage from '../RemovedCartItemMessage/RemovedCartItemMessage';

class CartItemsList extends React.PureComponent {
    static defaultProps = {
        deviceType: {},
        lastRemovedCartItem: {},
        quantityChangedItems: [],
    };

    static propTypes = {
        orderItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        orderAdjustments: PropTypes.arrayOf(PropTypes.object).isRequired,
        lastRemovedCartItem: PropTypes.objectOf(PropTypes.object),
        currency: PropTypes.string.isRequired,
        deviceType: PropTypes.objectOf(PropTypes.bool),
        quantityChangedItems: PropTypes.arrayOf(PropTypes.string),
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.cartItemsRenderer = this.cartItemsRenderer.bind(this);
    }

    /**
     * Returns CartItem component for a particular index
     */
    getCartItem(dataItem, index, addPTAfterItemRemoval = false) {
        const { orderAdjustments, currency, deviceType, quantityChangedItems } = this.props;

        return (
            <div className={dt([addPTAfterItemRemoval && '!pt-4'])} id={dataItem.id}>
                <CartItem
                    index={index}
                    orderItem={dataItem}
                    orderAdjustments={orderAdjustments}
                    currency={currency}
                    deviceType={deviceType}
                    quantityChangedItems={quantityChangedItems}
                />
            </div>
        );
    }

    /**
     * Returns removed cart item message component
     */
    getRemovedCartItemMessage() {
        const { lastRemovedCartItem } = this.props;
        return <RemovedCartItemMessage removedItem={lastRemovedCartItem} />;
    }

    cartItemsRenderer(dataItem, index) {
        const { lastRemovedCartItem, orderItems } = this.props;

        // Rendering with removal message
        if (!isEmpty(lastRemovedCartItem)) {
            // removal in case the api has not cleared the data
            if (dataItem.id === lastRemovedCartItem.id) {
                return this.getRemovedCartItemMessage();
            }

            // inserting the removal message
            if (lastRemovedCartItem.index === index) {
                return (
                    <>
                        {this.getRemovedCartItemMessage()}
                        {this.getCartItem(dataItem, index, true)}
                    </>
                );
            }

            // inserting the removal message if item removed from last
            if (
                lastRemovedCartItem.index === orderItems.length &&
                index + 1 === orderItems.length
            ) {
                return (
                    <>
                        {this.getCartItem(dataItem, index)}
                        {this.getRemovedCartItemMessage()}
                    </>
                );
            }
        }

        return this.getCartItem(dataItem, index);
    }

    render() {
        const { orderItems } = this.props;

        return (
            <div className={styles.cartItemList} data-automation-id="at-product-detail">
                <List
                    direction={config.direction.VERTICAL}
                    spacing="None"
                    datasource={orderItems}
                    childRenderer={this.cartItemsRenderer}
                    listStyleClass={null}
                    automationId="at-product-details-list"
                />
            </div>
        );
    }
}

export default CartItemsList;
